import type { RunDTO } from "../../shared/types";
import { Link } from "../lib/router";
import { RunCost } from "./CostBreakdown";
import { duration, StatusBadge } from "./ui";

export function RunTree({ runs, activeId }: { runs: RunDTO[]; activeId?: string }) {
  const children = new Map<string | null, RunDTO[]>();
  for (const r of runs) children.set(r.parentRunId, [...(children.get(r.parentRunId) ?? []), r]);
  const ids = new Set(runs.map((r) => r.id));
  const roots = runs.filter((r) => !r.parentRunId || !ids.has(r.parentRunId));

  const node = (r: RunDTO) => (
    <li key={r.id}>
      <Link
        to={`/admin/runs/${r.id}`}
        className={`flex items-center gap-2 rounded px-2 py-1 text-sm ${r.id === activeId ? "bg-fill" : "hover:bg-fill-subtle"}`}
      >
        <StatusBadge status={r.status} />
        <span className="font-medium">{r.agentName}</span>
        <span className="text-xs text-faint">{r.mode}</span>
        <span className="min-w-0 flex-1 truncate text-xs text-muted">{r.task}</span>
        <span className="text-xs text-faint">{duration(r.startedAt, r.finishedAt)}</span>
        <span className="text-xs text-faint"><RunCost usd={r.costUsd} paidBy={r.paidBy} /></span>
      </Link>
      {children.get(r.id)?.length ? <ul className="ml-4 border-l border-line pl-2">{children.get(r.id)!.map(node)}</ul> : null}
    </li>
  );

  return <ul className="space-y-0.5">{roots.map(node)}</ul>;
}
